"use strict";
(self["webpackChunk_N_E"] = self["webpackChunk_N_E"] || []).push([[745],{

/***/ 946:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

// ESM COMPAT FLAG
__webpack_require__.r(__webpack_exports__);

// EXPORTS
__webpack_require__.d(__webpack_exports__, {
  "default": function() { return /* reexport */ products_Products; }
});

// EXTERNAL MODULE: ./node_modules/react/jsx-runtime.js
var jsx_runtime = __webpack_require__(5893);
// EXTERNAL MODULE: ./node_modules/react/index.js
var react = __webpack_require__(7294);
// EXTERNAL MODULE: ./core/contexts/app/index.tsx + 1 modules
var contexts_app = __webpack_require__(9617);
// EXTERNAL MODULE: ./core/utils/index.ts + 2 modules
var utils = __webpack_require__(58);
// EXTERNAL MODULE: ./components/base/image/Image.tsx
var Image = __webpack_require__(4297);
// EXTERNAL MODULE: ./node_modules/begonya/functions/index.js
var functions = __webpack_require__(44);
// EXTERNAL MODULE: ./components/base/gridview/index.tsx + 4 modules
var gridview = __webpack_require__(7923);
;// CONCATENATED MODULE: ./components/widgets/products/Products.tsx







function _defineProperty(obj, key, value) {
    if (key in obj) {
        Object.defineProperty(obj, key, {
            value: value,
            enumerable: true,
            configurable: true,
            writable: true
        });
    } else {
        obj[key] = value;
    }
    return obj;
}
function _objectSpread(target) {
    for(var i = 1; i < arguments.length; i++){
        var source = arguments[i] != null ? arguments[i] : {};
        var ownKeys = Object.keys(source);
        if (typeof Object.getOwnPropertySymbols === "function") {
            ownKeys = ownKeys.concat(Object.getOwnPropertySymbols(source).filter(function(sym) {
                return Object.getOwnPropertyDescriptor(source, sym).enumerable;
            }));
        }
        ownKeys.forEach(function(key) {
            _defineProperty(target, key, source[key]);
        });
    }
    return target;
}
var Products = function(param) {
    var title = param.title, subTitle = param.subTitle, image = param.image, background = param.background, isStatic = param.isStatic, product = param.product, description = param.description;
    var app = (0,contexts_app/* useApp */.qD)();
    var imageRef = (0,react.useRef)(null);
    var titleRef = (0,react.useRef)(null);
    var backgroundURL = utils/* path.asset */.E.asset(app.environment, background && background.src);
    return(/*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
        className: (0,functions.classnames)('products', isStatic && 'producs--static'),
        style: {
            background: "url('".concat(backgroundURL, "')")
        },
        children: /*#__PURE__*/ (0,jsx_runtime.jsxs)("div", {
            className: "products-parallax",
            children: [
                /*#__PURE__*/ (0,jsx_runtime.jsx)("h1", {
                    ref: titleRef,
                    className: "products-title",
                    children: title
                }),
                !isStatic && /*#__PURE__*/ (0,jsx_runtime.jsxs)("div", {
                    ref: imageRef,
                    className: "products-layer",
                    children: [
                        /*#__PURE__*/ (0,jsx_runtime.jsx)(Image/* default */.Z, _objectSpread({}, image, {
                            alt: ""
                        })),
                        /*#__PURE__*/ (0,jsx_runtime.jsx)(gridview/* Container */.W2, {
                            size: "extended",
                            children: /*#__PURE__*/ (0,jsx_runtime.jsx)(gridview/* Row */.X2, {
                                children: /*#__PURE__*/ (0,jsx_runtime.jsxs)("div", {
                                    className: "products-description",
                                    children: [
                                        /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                                            className: "products-description-head",
                                            children: /*#__PURE__*/ (0,jsx_runtime.jsxs)("div", {
                                                className: "products-description-head-title",
                                                children: [
                                                    /*#__PURE__*/ (0,jsx_runtime.jsx)("span", {
                                                        children: subTitle
                                                    }),
                                                    product
                                                ]
                                            })
                                        }),
                                        description && /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                                            className: "products-description-text",
                                            dangerouslySetInnerHTML: {
                                                __html: description
                                            }
                                        })
                                    ]
                                })
                            })
                        })
                    ]
                })
            ]
        })
    }));
};
/* harmony default export */ var products_Products = (Products);

;// CONCATENATED MODULE: ./components/widgets/products/index.ts



/***/ })

}]);